export default "/images/vendor/flag-icon-css/flags/1x1/fi.svg?eb793b740dd4fa0f8b6301a4b74a435e";